<div *ngIf="vehcilesList.values.length > 1" class="ffq-lib__driver-card">
    <div class="ridesharetxt">Which are the Rideshare vehicle(s)?</div>
 <div><lib-check-box [params]="vehcilesList"></lib-check-box></div>
     </div>

<div *ngIf="driverList.values.length > 1" class="ffq-lib__driver-card">
    <div class="ridesharetxt"> Who are the Rideshare driver(s)?</div>
       <div>  <lib-check-box [params]="driverList"></lib-check-box></div> 
</div>